import React from "react";
import "./styles.css";
class Button1 extends React.Component {
	render() {
		const { variant, content, ...others } = this.props;
		const buttonclass = "buttoncomponent " + variant;
		return (
			<button className={buttonclass} onClick={this.props.onClick}>
				<i className={this.props.icon} aria-hidden="true"></i>
				{content}
			</button>
		);
	}
}
export default Button1;
